import { get } from "lodash";
import { createSelector } from "reselect";

const investmentEditMode = state => get(state, "investmentEditMode", Boolean());

export const editMode = createSelector(
  investmentEditMode,
  editModeValue => editModeValue
);
